import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Input from '@material-ui/core/Input';
import { useContext, useEffect, useState } from 'react';
import RichEditor from '../../commons/RichEditor';
import StyledDropzone from '../../commons/StyledDropzone';
import { TestContext } from '../../Context/TestContext';
import style from './style';

const placeholder = () => {
  return (
    <>
      <span style={{ fontSize: 26, margin: 8 }}>+</span>
      <span>Ajouter une photo</span>
    </>
  );
};

const EgalityVariableCreationForm = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState('');

  const { test, updateTest } = useContext<any>(TestContext);

  const cls = style();
  useEffect(() => {
    if (test.egalityVariable.name.length > 0) {
      setName(test?.egalityVariable?.name ?? '');
      setDescription(test?.egalityVariable?.description ?? '');
      setImage(test?.egalityVariable?.image ?? '');
    }
  }, [test]);

  const handleNameChange = (e: any) => {
    setName(e.target.value);
  };

  const handleDescriptionChange = (value: string) => {
    setDescription(value);
  };

  const handleFileUrlChange = (url: string) => {
    setImage(url);
  };

  const resetState = () => {
    setName('');
    setDescription('');
    setImage('');
  };

  const addVariable = async () => {
    await updateTest({
      ...test,
      egalityVariable: { name, description, image, id: test.egalityVariable.id },
    });
  };

  return (
    <Card variant="outlined" style={{ padding: 15, borderRadius: '10px', marginTop: 10 }}>
      <h3 className={cls.h3}>Nom</h3>
      <Input
        value={name}
        onChange={handleNameChange}
        placeholder="Renseignez le nom"
        type="text"
        className={cls.input}
      />
      <h3 className={cls.h3}>Descriptif du résultat</h3>
      <RichEditor value={description} handleChange={handleDescriptionChange} />
      {/* <div style={{paddingTop: 20, paddingBottom: 20}}>
        <StyledDropzone
          placeholder={placeholder}
          handleFileUrlChange={handleFileUrlChange}
          pathPrefix="variables"
          fileUrl={image}
        />
      </div> */}
      <Box className={cls.btnPrimaryContainer}>
        <Button className={cls.btnPrimary} disabled={name.length === 0} onClick={addVariable}>
          {test.egalityVariable.name.length > 0 ? 'Modifier la variable' : 'Ajouter la variable'}
        </Button>
      </Box>
    </Card>
  );
};

export default EgalityVariableCreationForm;
